// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w-164px[data-v-048ad0ca]{width:164px}.pt-thumbnail-shoplist[data-v-048ad0ca]{position:relative;padding-top:100%;overflow:hidden}@media (min-width: 768px){.pt-thumbnail-shoplist[data-v-048ad0ca]{padding-top:67.86885%}.w-285px[data-v-048ad0ca]{width:285px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
